export const alert = {
  title: "Important",
  greeting: "Hello",
  user_default: "User",
  feature_title: "Complete your banking info",
  feature_description: "To create in",
  feature_1: "Professional quotes",
  feature_2: "Detailed invoices",
  feature_3: "Credit notes and refunds",
  requirements_title: "📋 Required information:",
  req_bank_name: "Bank name",
  req_iban: "IBAN / Account number",
  req_bic: "BIC/SWIFT code",
  req_address: "RIB",
  add_button: "Add banking information",
  remind_later: "Remind me later",
  footer: "⏱️ Takes less than 2 minutes",
};
